import React from 'react';
import * as Datetime from 'react-datetime';
import moment from 'moment';
import isEqual from 'lodash.isequal';
import Calendar16 from '@carbon/icons-react/lib/calendar/16';

export default class DateTimePicker extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(nextProps, this.props);
  }

  renderInput = (props, openCalendar) => {
    return (
      <div className={'bx--date-picker-input__wrapper'}>
        <input
          {...props}
          className={"bx--text-input " + (this.props.invalid ? " bx--text-input--invalid" : "")}
          disabled={this.props.disabled || false}
          placeholder={this.props.placeholder || ""}
        />
        <Calendar16
          className={`bx--date-picker__icon`}
          aria-label="Open Calendar"
          onClick={this.props.disabled ? () => { } : openCalendar}
          role="img">
        </Calendar16>
      </div>
    );
  }

    validateDate = (inputValue) => {
      const today = moment();
      if (this.props.disableFutureDate) return inputValue.isBefore(today)
      if (this.props.disablePastDate) return inputValue.isAfter(today);
      return true
    }

    render() {
      const {
        name,
        alt,
        className
      } = this.props;

      let value = "";
      if (this.props.value) {

        if (this.props.type === "date") {
          value = moment.utc(this.props.value, "YYYY-MM-DD");
        } else {
          value = moment.utc(this.props.value);
        }
      }
      const _dateFormat = (this.props.type === "date" || this.props.type === "datetime" || !this.props.type) ? "DD/MM/YYYY" : false;

      const _onChange = (value) => {//value substring 3: if < 9 add 0
       if (!value) {
          this.props.onChange(name, null, alt);
          return;
        }
        try {
          if (!value.isValid()) return;
          var date = '';
          if (this.props.type === "date") {
            date = value.format("YYYY-MM-DD");
          } 
          this.props.onChange(name, date, alt);
          return;
        }
        catch { return null;
        }
      };

      return (
        <Datetime
          renderInput={this.renderInput}
          value={value}
          dateFormat={_dateFormat}
          timeFormat={false}
          onChange={_onChange}
          className={className || ''}
          closeOnSelect={this.props.type === "date"}
          isValidDate={this.validateDate}
        />
      );
  }
}
